import React, { useState, useEffect, useRef } from 'react'
import { Table, Button, Modal, Form } from "react-bootstrap";
import { axiosOpen } from "../../../../api/axios";
import { useNavigate } from "react-router-dom";
import { Toaster, toast } from 'react-hot-toast';

const SubscriptionList = () => {
  const navigate = useNavigate();
  const [subscriptions, setSubscriptions] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState({})
  const isComponentMounted = useRef(false);

  async function getSubscriptionPlan() {
    try {
      const response = await axiosOpen.get('subscription/list');
      isComponentMounted.current && setSubscriptions(response?.data || []);
    } catch (error) {
      toast.error(error.response.data.message || "Oops! something went wrong.")
    }
  }

  function handleAdd() {
    navigate("/subscription/add", { replace: true });
  }


  async function processDeletion() {
    try {
      await axiosOpen.put(`subscription/update/${selectedPlan._id}`, {
        name: selectedPlan.name,
        status: true,
        listings: selectedPlan.listings
      });
      setDeleteModal(false);
      toast.success("Subscription Plan Deleted.");
      getSubscriptionPlan();
    } catch (error) {
      toast.error(error.response.data.message || "Oops! something went wrong.")
    }

  }

  async function handleStatusChange(e, subscription) {
    try {
      const response = await axiosOpen.put(`subscription/update/${subscription._id}`, {
        name: subscription.name,
        status: e.target.checked,
        listings: subscription.listings
      });
      toast.success("Subscription Plan Status Updated.");
    } catch (error) {
      toast.error(error.response.data.message || "Oops! something went wrong.")
    }
  }

  useEffect(() => {
    isComponentMounted.current = true;
    getSubscriptionPlan();

    return () => {
      isComponentMounted.current = false;
    }
  }, []);

  return (
    <div className='wrapper bg-white'>
      <Toaster
        position="top-right"
        reverseOrder={false}
      />
      <div className='page-header'>
        <h2>Subscription Plans</h2>
        <Button onClick={handleAdd}>Add Subscription</Button>
      </div>
      <Table responsive>
        <thead className='table-header-sticky'>
          <tr>
            <th>Status</th>
            <th>Name</th>
            <th>Price</th>
            <th>Feature</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {subscriptions.map(subscription => (
            <tr key={subscription._id}>
              <td>
                {subscription.subscription_status === 'true' ? 'Active' : 'Inactive'}
              </td>
              <td>{subscription.name}</td>
              <td>{subscription.currency} {subscription.amount}</td>
              <td>{subscription.description}</td>
              <td>
                <Button variant="primary" onClick={() => navigate(`/subscription/edit/${subscription._id}`, { replace: true })}>Edit</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Modal show={deleteModal} onHide={() => setDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Are you sure?</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you really want to delete this subscription plan? This process cannnot be undone.</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={processDeletion}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default SubscriptionList